export const DICTIONARY = {
	100: 'Por aprobar',
	200: 'Aprobada',
	300: 'Rechazada',
	400: 'Completada',
};
